<template>

    <v-card
		color="brightBackground"
		flat
		tile
        height="100%"
	>

        <v-container fluid style="max-width: 1000px;">

            <!-- Form -->
            <v-form ref="newGroupForm">

            <v-row>

                <v-col
                    align="center"
                    justify="center"
                >
                    <v-row no-gutters>
                        <v-subheader class="display-1 font-weight-bold pl-3 mt-5 ml-0 mb-3 pb-5 grey--text text--darken-3">Create project group</v-subheader>
                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="8" xs="12" sm="12" md="8" xl="8" class="px-3">
                            <v-text-field
                                label="Group name"
                                v-model="groupData.name"
                                :rules="agile.fieldRules.nameRules"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" xs="12" sm="12" md="4" xl="4" class="px-3">
                            <v-select
                                v-model="client"
                                :items="clients"
                                item-text="name"
                                item-value="id"
                                :rules="agile.fieldRules.requiredRule"
                                label="Client"
                                outlined
                                dense
                                return-object
                                
                            ></v-select>
                        </v-col>

                    </v-row>


                    <v-row no-gutters>

                        <v-col cols="6" xs="12" sm="12" md="8" xl="8" class="px-3">
                            <v-text-field
                                label="Group safe name (for use with variables, urls etc.)"
                                v-model="groupData.variable"
                                :rules="agile.fieldRules.variableRules"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" xs="12" sm="12" md="4" xl="4" class="px-3">
                            <v-text-field
                                label="Group prefix name"
                                v-model="groupData.prefix"
                                :rules="agile.fieldRules.prefixRules"
                                outlined
                                dense
                                
                            ></v-text-field>
                        </v-col>

                        
                    </v-row>


                    <v-row no-gutters>

                        <v-col align="right">
                            <v-btn color="iconTextColor" class="mr-3" small text router to="/admin/groups">
                                <v-icon medium class="pr-1">mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                            <v-btn color="iconTextColor" class="mr-3" small text @click="createGroup">
                                <v-icon medium class="pr-1">mdi-check-bold</v-icon>
                                Create group
                            </v-btn>
                        </v-col>
                        
                    </v-row>

                </v-col>

            </v-row>

            </v-form>

        </v-container>
    </v-card>

</template>




<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';


export default
{
    name: 'NewGroup',

    // ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		clients: [],
        client: {},

        groupData:
        {
            name: '',
            variable: '',
            prefix: '',
            clientId: '',
        },

        
	}),

    computed:
	{
        // Get agile for the field rules (for validating)
        agile()
        {
            return agile;
        },
    },


    // ----------------------------------------------------
    //
    //  VUE: Create and Mount
    //
    // ----------------------------------------------------
    
    created()
    {
		this.loadClients();
    },

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
    //
    //	VUE: Methods
    //
	// --------------------------------------------------------------------
    
	methods:
	{

        // ----------------------------------
        //	Load client list and let it
        //  live reload!
        // ----------------------------------

        loadClients()
        {
            
            
            fb.db.collection('clients').onSnapshot(res =>
            {
                const changes = res.docChanges();

                changes.forEach(change =>
                {

                    // ----------------------------------
                    //	Content added
                    // ----------------------------------

                    if (change.type === 'added')
                    {
                        this.clients.push(
                        {
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                    }


                    // ----------------------------------
                    //	Content modified
                    // ----------------------------------

                    if (change.type === "modified")
                    {
                        for (let i = 0; i < this.clients.length; i++)
                        {
                            if (this.clients[i].id == change.doc.id)
                            {
                                var uD = change.doc.data();
                                this.clients[i].name = uD.name;
                                this.clients[i].variable = uD.variable;
                                this.clients[i].prefix = uD.prefix;
                                this.clients[i].id = change.doc.id;
                            }
                        }
                    }


                    // ----------------------------------
                    //	Content deleted
                    // ----------------------------------

                    if (change.type === "removed")
                    {
                        for (let i = 0; i < this.clients.length; i++)
                        {
                            if (this.clients[i].id == change.doc.id)
                            {
                                this.clients.splice(i, 1);
                            }
                        }
                    } 
                });

                this.agile.sortBy(this.clients, 'name');
            },
            er =>
            {
                this.$root.$alert("Error", er.message);
            });
        },


        // ----------------------------------
        //	Create group
        // ----------------------------------

        createGroup()
        {
            if (this.validate())
            {
                
                this.$root.ai_app.showProgressWheel = true;

                //console.log(this.client);

                /* let a = "b";
                if (a == "b") return; */

                // ----------------------------------
                //	Create group in Firebase
                // ----------------------------------

                fb.db.collection('project-groups').add(
				{
                    name: this.groupData.name,
                    variable: this.groupData.variable,
                    clientId: this.client.id,
                    clientName: this.client.name,
                    prefix: this.groupData.prefix.toLowerCase(),
                    key: this.client.prefix+"-"+this.groupData.prefix.toLowerCase(),
                    accessMap:
                    {
                        master: this.client.prefix,
                        group: this.groupData.prefix.toLowerCase(),
                        project: '*',
                    } 
				})
                .then(() =>
                {
                    this.$root.ai_app.snackbarText = 'Project group created';
                    this.$root.ai_app.snackbarTimeout = 3000;
                    this.$root.ai_app.snackbar = true;
                    this.$root.ai_app.showProgressWheel = false;
                    this.$router.push('/admin/groups');
                })
                .catch((error) =>
                {
                    this.$root.ai_app.showProgressWheel = false;
                    this.$root.$alert("Error", error.message);
                });

            }
            
        },


        // ----------------------------------
        //	Form validation
        // ----------------------------------
        
        validate()
        {
            this.groupData.prefix = this.groupData.prefix.toLowerCase();
            return this.$refs.newGroupForm.validate();
        },

        resetValidation()
        {
            this.$refs.newGroupForm.resetValidation();
        },

	},



	// ----------------------------------
	//	VUE: Components
	// ----------------------------------

    components:
    {
        
    }

}
</script>